export const dateLocale = (lng) => ({ de: 'de-DE', en: 'en-GB', it: 'it-IT', es: 'es-ES' }[(lng || 'de').split('-')[0]] || 'de-DE');
